<div class="filter-chips-container flex wrap vcenter">
  <app-invoice-number-filter [control]="invoiceNumber"></app-invoice-number-filter>
  <app-invoice-client-name-filter [control]="clientName"></app-invoice-client-name-filter>
  <app-invoice-client-tax-number-filter [control]="clientTaxNumber"></app-invoice-client-tax-number-filter>
  <app-invoice-debtor-name-filter [control]="debtorName"></app-invoice-debtor-name-filter>
  <app-invoice-debtor-tax-number-filter [control]="debtorTaxNumber"></app-invoice-debtor-tax-number-filter>
  @if (hasActiveFilters) {
    <button
      class="clear-all-filters-btn"
      type="button"
      (click)="clearAllFilters()"
    >
      Szűrők törlése
    </button>
  }
  @if (loading()) {
    <mat-progress-spinner
      mode="indeterminate"
      diameter="24"
    ></mat-progress-spinner>
  }
</div>

<table
  mat-table
  multiTemplateDataRows
  matSort
  class="mat-elevation-z1 top-margin-15"
  id="invoice-table"
  [dataSource]="dataSource"
  [matSortDisabled]="loading()"
  (matSortChange)="sortChange()"
>
  <ng-container matColumnDef="invoice_number">
    <th
      *matHeaderCellDef
      mat-header-cell
      mat-sort-header
    >
      Számla Azonosító
    </th>
    <td
      *matCellDef="let element"
      mat-cell
    >
      {{ element.invoice_number }}
    </td>
  </ng-container>

  <ng-container matColumnDef="type">
    <th
      *matHeaderCellDef
      mat-header-cell
    >
      Számla Típusa
    </th>
    <td
      *matCellDef="let element"
      mat-cell
    >
      {{ invoiceTypeLabel[$any(element.type)] ?? element.type }}
    </td>
  </ng-container>

  <ng-container matColumnDef="client_name">
    <th
      *matHeaderCellDef
      mat-header-cell
      mat-sort-header
    >
      Hitelező Neve
    </th>
    <td
      *matCellDef="let element"
      mat-cell
    >
      {{ element.client_name }}
    </td>
  </ng-container>

  <ng-container matColumnDef="client_tax_number">
    <th
      *matHeaderCellDef
      mat-header-cell
      mat-sort-header
    >
      Hitelező Adószáma
    </th>
    <td
      *matCellDef="let element"
      mat-cell
    >
      {{ element.client_tax_number }}
    </td>
  </ng-container>

  <ng-container matColumnDef="debtor_name">
    <th
      *matHeaderCellDef
      mat-header-cell
      mat-sort-header
    >
      Adós Neve
    </th>
    <td
      *matCellDef="let element"
      mat-cell
    >
      {{ element.debtor_name }}
    </td>
  </ng-container>

  <ng-container matColumnDef="debtor_tax_number">
    <th
      *matHeaderCellDef
      mat-header-cell
      mat-sort-header
    >
      Adós Adószáma
    </th>
    <td
      *matCellDef="let element"
      mat-cell
    >
      {{ element.debtor_tax_number }}
    </td>
  </ng-container>

  <ng-container matColumnDef="amount">
    <th
      *matHeaderCellDef
      mat-header-cell
    >
      Számla Összege
    </th>
    <td
      *matCellDef="let element"
      mat-cell
    >
      <span>{{ element.remaining_amount | number: "1.0" : "hu" }}&nbsp;{{ element.currency_iso }}</span>
      <span color="grey-dark">&nbsp;/&nbsp;{{ element.original_amount | number: "1.0" : "hu" }}&nbsp;{{ element.currency_iso }}</span>
    </td>
  </ng-container>

  <ng-container matColumnDef="due_date_at">
    <th
      *matHeaderCellDef
      mat-header-cell
      mat-sort-header
    >
      Fizetési Határidő
    </th>
    <td
      *matCellDef="let element"
      mat-cell
    >
      {{ element.due_date_at | date: "yyyy.MM.dd." }}
    </td>
  </ng-container>

  <ng-container matColumnDef="issued_at">
    <th
      *matHeaderCellDef
      mat-header-cell
      mat-sort-header
    >
      Számla Kelte
    </th>
    <td
      *matCellDef="let element"
      mat-cell
    >
      {{ element.issued_at | date: "yyyy.MM.dd." }}
    </td>
  </ng-container>

  <ng-container matColumnDef="detail-column">
    <td
      *matCellDef="let element"
      mat-cell
      [attr.colspan]="displayedColumns.length"
    >
      @if (expandedElement === element) {
        <div>
          @if (!expandedDetails) {
            <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
          }
          @if (expandedDetails) {
            <div class="flex">
              @if (expandedDetails.corrections.length > 0) {
                <div class="flex column">
                  <h2>Helyesbítő számlák</h2>
                  <table>
                    <tr>
                      <th>Számla azonosító</th>
                      <th>Számla összege</th>
                      <th>Fizetési határidő</th>
                      <th>Számla kelte</th>
                    </tr>
                    @for (correction of expandedDetails.corrections; track correction.id) {
                      <tr>
                        <td>{{ correction.invoice_number }}</td>
                        <td>
                          {{ correction.remaining_amount | number: "1.0" : "hu" }} /
                          {{ correction.original_amount | number: "1.0" : "hu" }}
                        </td>
                        <td>{{ correction.due_date_at | date: "yyyy.MM.dd." }}</td>
                        <td>{{ correction.issued_at | date: "yyyy.MM.dd." }}</td>
                      </tr>
                    }
                  </table>
                </div>
              }
              @if (expandedDetails.payee_cases.length > 0) {
                <div class="flex column">
                  <h2>Ügyek</h2>
                  <table>
                    <tr>
                      <th>Ügy azonosító</th>
                      <th>Termék</th>
                      <th>Státusz</th>
                    </tr>
                    @for (payee_case of expandedDetails.payee_cases; track payee_case.id) {
                      <tr>
                        <td>{{ payee_case.payee_case_reference_id }}</td>
                        <td>{{ payee_case.product_label }}</td>
                        <td>{{ payee_case.state_label }}</td>
                      </tr>
                    }
                  </table>
                </div>
              }
            </div>
          }
        </div>
      }
    </td>
  </ng-container>

  <tr
    *matHeaderRowDef="displayedColumns"
    mat-header-row
  ></tr>
  <tr
    *matRowDef="let element; columns: displayedColumns"
    mat-row
    class="element-row"
    (click)="updateExpandedElement(element)"
  ></tr>
  <tr
    *matRowDef="let element; columns: ['detail-column']"
    mat-row
    class="detail-row"
  ></tr>
</table>

<mat-paginator
  class="mat-elevation-z1"
  [disabled]="loading()"
  [pageSize]="pageSize"
  [pageIndex]="pageIndex"
  [pageSizeOptions]="[5, 10, 25, 100]"
  [length]="length"
  (page)="pageChange($event)"
></mat-paginator>
